module.exports = __webpack_public_path__ + "static/media/foot.39567d5d.png";